/* Photo navigation enhances native links/details. No data collection or cart writes. */
(() => {
  if (window.eosPhotoDiscoveryLoaded) return;
  window.eosPhotoDiscoveryLoaded = true;
  const prepared = new WeakSet();
  const repairController = home => {
    const ctor = customElements.get('eos-everyday-home');
    if (!ctor || !(home instanceof ctor)) return;
    const panel = home.querySelector('[data-eos-dialog-content]');
    if (!panel) return;
    // A custom element can connect before its children are available in a rerender.
    if (home.events && home.panel !== panel) {
      if (typeof home.disconnectedCallback === 'function') home.disconnectedCallback();
    }
    if (!home.events && typeof home.connectedCallback === 'function') home.connectedCallback();
    if (!home._photoQuickGuard && typeof home.openQuick === 'function') {
      const original = home.openQuick.bind(home);
      home.openQuick = async link => {
        try { await original(link); }
        catch (error) {
          // Never turn a valid product link into a dead end if the preview fails.
          const url = new URL(link.href, location.href);
          if (url.origin === location.origin && url.pathname.includes('/products/')) location.assign(url.href);
        }
      };
      home._photoQuickGuard = true;
    }
  };
  const enhance = home => {
    const guide = home.querySelector('[data-eos-guide]');
    if (!guide || !home.querySelector('[data-eos-dialog-content]')) return;
    repairController(home);
    if (prepared.has(guide)) return;
    prepared.add(guide);
    const links = [...guide.querySelectorAll('[data-eos-reveal]')];
    const panels = [...guide.querySelectorAll('[data-eos-feeling]')];
    if (!links.length || !panels.length) return;
    guide.dataset.photoReady = 'true';
    const sync = () => {
      links.forEach(link => {
        const panel = panels.find(item => item.dataset.eosFeeling === link.dataset.eosReveal);
        if (panel) {
          link.setAttribute('aria-expanded', String(panel.open));
          link.setAttribute('aria-controls', panel.id);
        }
      });
    };
    guide.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target.closest('[data-eos-reveal]') : null;
      if (!target || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (typeof event.button === 'number' && event.button > 0)) return;
      const panel = panels.find(item => item.dataset.eosFeeling === target.dataset.eosReveal);
      if (!panel) return;
      event.preventDefault();
      const wasOpen = panel.open;
      panels.forEach(item => { item.open = item === panel && !wasOpen; });
      sync();
      if (!wasOpen) {
        requestAnimationFrame(() => {
          panel.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          panel.querySelector('summary')?.focus({preventScroll:true});
        });
      }
    });
    panels.forEach(panel => panel.addEventListener('toggle', sync));
    sync();
  };
  let scheduled = false;
  const scan = () => {
    scheduled = false;
    document.querySelectorAll('eos-everyday-home').forEach(enhance);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, {once:true});
  else scan();
  customElements.whenDefined('eos-everyday-home').then(scan);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('eos-everyday-home,[data-eos-guide],[data-eos-dialog-content]') || node.querySelector?.('eos-everyday-home'))))) schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
